import type { Workspace } from "../types";

const LOGOS = {
  dif: "/logos/dif.svg",
  ugandaGov: "/logos/uganda-gov.svg",
  ugandaMoh: "/logos/uganda-moh.svg",
  stratus: "/logos/stratus.svg",
  philanthrify: "/logos/philanthrify.svg",
};

// Workspace A — Uganda Fire Stations 2026–2029 (primary demo)
export const ugandaFireStationsWorkspace: Workspace = {
  id: "uganda-fire-stations",
  programmeName: "Uganda Fire Stations 2026–2029",
  funder: { name: "Danish Impact Fund", logo: LOGOS.dif },
  recipient: { name: "Government of Uganda", logo: LOGOS.ugandaGov },
  oversight: { name: "Stratus Health", logo: LOGOS.stratus },
  technology: { name: "Philanthrify", logo: LOGOS.philanthrify },
  accentHsl: "218 88% 48%", // clean institutional azure
  compliancePackName: "Uganda Sovereignty Bill 2026 + DPPA 2019",
  coverImageUrl:
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1600&q=60",
  terminology: {},
  programmeId: 1,
};

// Workspace B — Maternal Health Northern Uganda 2026–2028 (multi-tenant variety)
export const maternalHealthWorkspace: Workspace = {
  id: "maternal-health-northern-uganda",
  programmeName: "Maternal Health Northern Uganda 2026–2028",
  funder: { name: "Danish Impact Fund", logo: LOGOS.dif },
  recipient: { name: "Government of Uganda · Ministry of Health", logo: LOGOS.ugandaMoh },
  oversight: { name: "Stratus Health", logo: LOGOS.stratus },
  technology: { name: "Philanthrify", logo: LOGOS.philanthrify },
  accentHsl: "158 64% 38%", // clean emerald
  accentSoftAlpha: 0.12, // emerald is darker/less saturated; a higher soft alpha keeps tints legible
  compliancePackName: "Uganda Sovereignty Bill 2026 + DPPA 2019",
  coverImageUrl:
    "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?auto=format&fit=crop&w=1600&q=60",
  terminology: {
    primeContractor: "District health office",
    subProject: "Facility module",
  },
  programmeId: 2,
};

export const workspaces: Workspace[] = [ugandaFireStationsWorkspace, maternalHealthWorkspace];
export const workspacesById = Object.fromEntries(workspaces.map((w) => [w.id, w]));

export const DEFAULT_WORKSPACE_ID = ugandaFireStationsWorkspace.id;

/** Reverse lookup for the real numeric DB programme id server-side data
 * carries (e.g. actionPanel.js's items) back to the workspace slug this
 * client keys everything else by. Returns undefined for an id with no known
 * workspace (a demo item with no programmeId at all, or a programme this
 * fixed list doesn't cover) — callers should treat that as "can't resolve,
 * fall back to whatever's already active" rather than an error. */
export function workspaceIdForProgrammeId(programmeId?: string | number | null): string | undefined {
  if (programmeId == null) return undefined;
  return workspaces.find((w) => String(w.programmeId) === String(programmeId))?.id;
}
